import { MsgHandler } from '../../core/app/msg/msgHandler';
import * as consts from '../../core/app/common/consts';
import { AppConfig } from '../../core/app/app.config';
import { setMaxTbmVelocity, setMinTbmVelocity, setMaxNaiNatAlt, setMinNaiNatAlt, setMaxCredibility, setMinCredibility } from '../../core/app/common/settings'
import { from } from 'rxjs';
import * as units from '../../core/app/common/units';


export class ParamsHandler extends MsgHandler {
  private static _self: ParamsHandler = null;

  private constructor() {
    super(consts.MSG_TYPE_PARAMS);
  }

  public static getSelf(): ParamsHandler {
    if (this._self == null)
      this._self = new ParamsHandler();
    return this._self;
  }

  handleMsg(msgObj: any): void {
    if (AppConfig.settings.ShowLogs)
      console.log("params msg:", msgObj);

    if (msgObj.MaxTbmVelocity != undefined)
      setMaxTbmVelocity(msgObj.MaxTbmVelocity * units.METER_SEC_TO_KNOT);

    if (msgObj.MinTbmVelocity != undefined)
      setMinTbmVelocity(msgObj.MinTbmVelocity * units.METER_SEC_TO_KNOT);

    if (msgObj.MaxRadarCredibility != undefined)
      setMaxCredibility(msgObj.MaxRadarCredibility);

    if (msgObj.MinRadarCredibility != undefined)
      setMinCredibility(msgObj.MinRadarCredibility);

    if (msgObj.MaxNaiNatAltitude != undefined)
      setMaxNaiNatAlt(msgObj.MaxNaiNatAltitude / 1000);

    if (msgObj.MinNaiNatAltitude != undefined)
      setMinNaiNatAlt(msgObj.MinNaiNatAltitude / 1000);
  }
}
